export default [{
    address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/bera.svg",
    isLpToken: !1,
    name: "BERA",
    symbol: "BERA"
}, {
    address: "0xfcbd14dc51f0a4d49d5e53c2e0950e0bc26d0dce",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/honey.svg",
    isLpToken: !1,
    name: "HONEY",
    symbol: "HONEY"
}, {
    address: "0x9b6761bf2397bb5a6624a856cc84a3a14dcd3fe5",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/ibera.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://infrared.finance/ibera",
    name: "iBERA",
    protocol: "infrared",
    symbol: "iBERA",
    type: "unknown"
}, {
    address: "0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/ibgt.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://infrared.finance/ibgt",
    name: "iBGT",
    protocol: "infrared",
    symbol: "iBGT",
    type: "vault"
}, {
    address: "0x6969696969696969696969696969696969696969",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wbera.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://hub.berachain.com/swap",
    name: "WBERA",
    protocol: "berachain",
    symbol: "WBERA",
    type: "unknown"
}, {
    address: "0xc4c039178a79e614609e592d7689ecb3107758b1",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/burr-nect.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://app.burrbear.io/#/berachain/pool/0xc4c039178a79e614609e592d7689ecb3107758b1000200000000000000000020/add-liquidity",
    name: "BURR-NECT",
    protocol: "burrbear",
    symbol: "20NECT-80BURR",
    type: "amm"
}, {
    address: "0x7185e6cb1fcaf5d9e67af065b5e0fd8503e68be2",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/swbera-wgbera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x7185e6cb1fcaf5d9e67af065b5e0fd8503e68be2000200000000000000000198/details/",
    name: "sWBERA-wgBERA (20/80)",
    protocol: "bex",
    symbol: "20sWBERA-80wgBERA-WEIGHTED",
    type: "amm"
}, {
    address: "0x53f786662ff5fbec135f913ab93c6b3366e90a46",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/asugar-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x53f786662ff5fbec135f913ab93c6b3366e90a4600020000000000000000014e/details",
    name: "aSUGAR-HONEY",
    protocol: "bex",
    symbol: "50aSUGAR-50HONEY-WEIGHTED",
    type: "amm"
}, {
    address: "0xd170e25f6bcb5ace2108628c647be47d59900ade",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/nect-plug.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://app.burrbear.io/#/berachain/pool/0xd170e25f6bcb5ace2108628c647be47d59900ade00020000000000000000000c/add-liquidity",
    name: "NECT-PLUG",
    protocol: "burrbear",
    symbol: "50NECT-50PLUG",
    type: "amm"
}, {
    address: "0xe416c064946112c1626d6700d1081a750b1b1dd7",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/nect-wgbera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://app.burrbear.io/#/berachain/pool/0xe416c064946112c1626d6700d1081a750b1b1dd7000200000000000000000008/add-liquidity",
    name: "NECT-wgBERA",
    protocol: "burrbear",
    symbol: "50NECT-50wgBERA",
    type: "amm"
}, {
    address: "0x09d4683d680abf2ecd69f4d6bcbc006abfe9f6ad",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/swbera-wgbera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x09d4683d680abf2ecd69f4d6bcbc006abfe9f6ad00020000000000000000018f/details/",
    name: "sWBERA-wgBERA",
    protocol: "bex",
    symbol: "50sWBERA-50wgBERA-WEIGHTED",
    type: "amm"
}, {
    address: "0x2c4a603a2aa5596287a06886862dc29d56dbc354",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/wbera-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x2c4a603a2aa5596287a06886862dc29d56dbc354000200000000000000000002/details",
    name: "WBERA-HONEY",
    protocol: "bex",
    symbol: "50WBERA-50HONEY-WEIGHTED",
    type: "amm"
}, {
    address: "0x4d0ac0ea757f0bb338457c7a135c41fc732ca67d",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wbera-ibera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x4d0ac0ea757f0bb338457c7a135c41fc732ca67d000200000000000000000005/details",
    name: "WBERA-iBERA",
    protocol: "bex",
    symbol: "50WBERA-50iBERA-WEIGHTED",
    type: "amm"
}, {
    address: "0x705fc16ba5a1eb67051934f2fb17eacae660f6c7",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wbera-lbgt.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x705fc16ba5a1eb67051934f2fb17eacae660f6c70002000000000000000000d5/details",
    name: "WBERA-LBGT",
    protocol: "bex",
    symbol: "50WBERA-50LBGT-WEIGHTED",
    type: "amm"
}, {
    address: "0x38fdd999fe8783037db1bbfe465759e312f2d809",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wbera-wbtc.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x38fdd999fe8783037db1bbfe465759e312f2d809000200000000000000000004/details",
    name: "WBERA-WBTC",
    protocol: "bex",
    symbol: "50WBTC-50WBERA-WEIGHTED",
    type: "amm"
}, {
    address: "0xdd70a5ef7d8cfe5c5134b5f9874b09fb5ce812b4",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wbera-weth.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0xdd70a5ef7d8cfe5c5134b5f9874b09fb5ce812b4000200000000000000000003/details",
    name: "WBERA-WETH",
    protocol: "bex",
    symbol: "50WETH-50WBERA-WEIGHTED",
    type: "amm"
}, {
    address: "0x1b7b061091bd2c900723107889fe44f825d6c921",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/wizz-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x1b7b061091bd2c900723107889fe44f825d6c92100020000000000000000010c/details",
    name: "WIZZ-WBERA",
    protocol: "bex",
    symbol: "50WIZZ-50WBERA-WEIGHTED",
    type: "amm"
}, {
    address: "0xac8a437d1e6905e419431662aead90fb04ac3008",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/burr-wgbera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://app.burrbear.io/#/berachain/pool/0xac8a437d1e6905e419431662aead90fb04ac300800020000000000000000000f/add-liquidity",
    name: "BURR-wgBERA",
    protocol: "burrbear",
    symbol: "80BURR-20wgBERA",
    type: "amm"
}, {
    address: "0x2461e93d5963c2bb69de499676763e67a63c7ba5",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/wbera-dinero.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x2461e93d5963c2bb69de499676763e67a63c7ba50002000000000000000000c2/details",
    name: "WBERA-DINERO",
    protocol: "bex",
    symbol: "80DINERO-20WBERA-WEIGHTED",
    type: "amm"
}, {
    address: "0xe9b91292fc29753a723ded3574f3ad8ec77d08dc",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/swbera-wgbera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0xe9b91292fc29753a723ded3574f3ad8ec77d08dc00020000000000000000019a/details/",
    name: "sWBERA-wgBERA (80/20)",
    protocol: "bex",
    symbol: "80sWBERA-20wgBERA-WEIGHTED",
    type: "amm"
}, {
    address: "0xf9845a03f7e6b06645a03a28b943c8a4b5fe7bcc",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/wbera-beramo.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://app.aquabera.com/vault/0xf9845a03f7e6b06645a03a28b943c8a4b5fe7bcc",
    name: "WBERA-BERAMO",
    protocol: "aquabera",
    symbol: "AB-KODIAK-WBERA-BERAMO-10000",
    type: "amm"
}, {
    address: "0x04fd6a7b02e2e48caedad7135420604de5f834f8",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/wbera-henlo.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://app.aquabera.com/vault/0x04fd6a7b02e2e48caedad7135420604de5f834f8",
    name: "WBERA-HENLO",
    protocol: "aquabera",
    symbol: "AB-KODIAK-WBERA-HENLO-10000",
    type: "amm"
}, {
    address: "0xcc6a16bcfda7d0ebe168f69ef7b946e96a90e67f",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/aibera.svg",
    isLpToken: !1,
    name: "HoneyFun AI",
    symbol: "AIBERA"
}, {
    address: "0x804cf700de1e18f2411bd05aad5fa10d60e1900f",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/asugar.svg",
    isLpToken: !1,
    name: "aSugar",
    symbol: "aSUGAR"
}, {
    address: "0x89d2e832edaaff8c228a57a1602a1f7950ea2d39",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/avl.svg",
    isLpToken: !1,
    name: "AVL",
    symbol: "AVL"
}, {
    address: "0xb5d46214f4ec7f910cb433e412d32ee817986e90",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/wbera-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://www.bulla.exchange/vault/details/wbera-honey-narrow",
    name: "WBERA-HONEY",
    protocol: "bulla",
    symbol: "aWBERA-HONEY",
    type: "amm"
}, {
    address: "0xcffbfd665bedb19b47837461a5abf4388c560d35",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wbera-ibgt.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://www.bulla.exchange/vault/details/wbera-ibgt-narrow",
    name: "WBERA-iBGT",
    protocol: "bulla",
    symbol: "aWBERA-iBGT",
    type: "amm"
}, {
    address: "0x93a0cb3ee34aa983db262f904021911ecd199228",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/bee.svg",
    isLpToken: !1,
    name: "Bee Token",
    symbol: "BEE"
}, {
    address: "0xc857f2ba47b0560e0b8fcd4dd82b943b5ee88d2b",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/beradrome-henlocked100m.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    isNotWorkingWithEnso: !0,
    isSoulbound: !0,
    mintUrl: "https://www.beradrome.com/farms/0x926aa5f8eb3193f853711806d3f7df3deba99aaf",
    name: "HENLOCKED100M",
    protocol: "beradrome",
    symbol: "Beradrome HENLOCKED100M",
    type: "unknown"
}, {
    address: "0xfb32f8c7d363790a6ccd89f8d20047612aba633b",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/beradrome-henlocked1b.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    isNotWorkingWithEnso: !0,
    isSoulbound: !0,
    mintUrl: "https://www.beradrome.com/farms/0x534b96f6f0b134a9fbb0eaa1881546dfb327b632",
    name: "HENLOCKED1B",
    protocol: "beradrome",
    symbol: "Beradrome HENLOCKED1B",
    type: "unknown"
}, {
    address: "0x94ca1028ee60e5b28cda22c0e7b6743017a9b7b6",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/beradrome-henlocked330m.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    isNotWorkingWithEnso: !0,
    isSoulbound: !0,
    mintUrl: "https://www.beradrome.com/farms/0xb6df86d016bb026f7dfd55a6a0361eab35ee2e7f",
    name: "HENLOCKED330M",
    protocol: "beradrome",
    symbol: "Beradrome HENLOCKED330M",
    type: "unknown"
}, {
    address: "0x94b12404d6163c3e49ed876fb25034a946a40dd8",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/beradrome-henlocked420m.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    isNotWorkingWithEnso: !0,
    isSoulbound: !0,
    mintUrl: "https://www.beradrome.com/farms/0xe909901b40225959972554b0cebe460b4213d194",
    name: "HENLOCKED420M",
    protocol: "beradrome",
    symbol: "Beradrome HENLOCKED420M",
    type: "unknown"
}, {
    address: "0x872130ced110e2a4325693c0802b6a0112b3615b",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/beradrome-henlocked690m.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    isNotWorkingWithEnso: !0,
    isSoulbound: !0,
    mintUrl: "https://www.beradrome.com/farms/0xde67e60209a42d62bb1eba4878efc4b3b367c172",
    name: "HENLOCKED690M",
    protocol: "beradrome",
    symbol: "Beradrome HENLOCKED690M",
    type: "unknown"
}, {
    address: "0xe8b92cd9771ebaad873a8e1b1b55404aecfdbc9d",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/plug-wbera.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    isSoulbound: !0,
    mintUrl: "https://www.beradrome.com/farms/0xaee71e1c9506f7a1fa6c7655657d239ebc31b5ae",
    name: "PLUG-WBERA",
    protocol: "beradrome",
    symbol: "Beradrome Kodiak PLUG-WBERA-V2",
    type: "unknown"
}, {
    address: "0x36fa291f4a4ae41e4be2a979136ebd7eb97950e7",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/wbera-locks.svg",
    imageCount: 2,
    isLpToken: !0,
    isSoulbound: !0,
    mintUrl: "https://www.beradrome.com/farms/0x74a38bfeedd95f65cbbf72eedf01eac77778bcf9",
    name: "WBERA-LOCKS",
    protocol: "beradrome",
    symbol: "Beradrome Kodiak WBERA-LOCKS-V2",
    type: "amm"
}, {
    address: "0x6fc6545d5cde268d5c7f1e476d444f39c995120d",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 4,
    image: "/assets/tokens/beraeth.svg",
    isLpToken: !1,
    name: "Berachain Staked ETH",
    symbol: "beraETH"
}, {
    address: "0x1f7210257fa157227d09449229a9266b0d581337",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/beramo.svg",
    isLpToken: !1,
    name: "BERAMO",
    symbol: "BERAMO"
}, {
    address: "0x656b95e550c07a9ffe548bd4085c72418ceb1dba",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/bgt.svg",
    isLpToken: !1,
    isSoulbound: !0,
    name: "Bera Governance Token",
    symbol: "BGT"
}, {
    address: "0x6b26f778bfae56cfb4bf9b62c678d9d40e725227",
    chainId: 80094,
    decimals: 8,
    displayPrecision: 0,
    image: "/assets/tokens/bitcoin.svg",
    isLpToken: !1,
    name: "HarryPotterObamaSonic10Inu",
    symbol: "BITCOIN"
}, {
    address: "0x147c9a7f5265d7ca9a671c3817b212a0cf88856e",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/bixbt.svg",
    isLpToken: !1,
    name: "BeraXBT",
    symbol: "BIXBT"
}, {
    address: "0xb749584f9fc418cf905d54f462fdbfdc7462011b",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/bm.svg",
    isLpToken: !1,
    name: "bm",
    symbol: "bm"
}, {
    address: "0xf05a207442f14e446b0e32b12d2043bfc68cb1c9",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/bold.svg",
    isLpToken: !1,
    name: "BOLD Stablecoin",
    symbol: "BOLD"
}, {
    address: "0xd352dc6e5f0c45e2f2b38eb5565eb286a1ea4087",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/br.svg",
    isLpToken: !1,
    name: "Bedrock",
    symbol: "BR"
}, {
    address: "0x93919784c523f39cacaa98ee0a9d96c3f32b593e",
    chainId: 80094,
    decimals: 8,
    displayPrecision: 8,
    image: "/assets/tokens/brbtc.svg",
    isLpToken: !1,
    name: "brBTC",
    symbol: "brBTC"
}, {
    address: "0x0003eedfdd020bf60d10cf684abac7c4534b7ead",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/bread.svg",
    isLpToken: !1,
    name: "Bread",
    symbol: "BREAD"
}, {
    address: "0x30e148a79b898efa1ab1285f5eca71972a7e0ace",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/bsumer.svg",
    isLpToken: !1,
    isSoulbound: !0,
    isUnpriced: !0,
    mintUrl: "https://app.sumer.money/?chain=80094",
    name: "bSumer",
    protocol: "sumer",
    symbol: "bSumer",
    type: "vault"
}, {
    address: "0xddd3ea5de9c70973e224d938b8f392ec4cc0171c",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/bull-ish-v2.svg",
    isLpToken: !1,
    isSoulbound: !0,
    isUnpriced: !0,
    mintUrl: "https://game.bullas.xyz",
    name: "BULL ISH V2",
    protocol: "bullish",
    symbol: "BULL ISH V2",
    type: "points"
}, {
    address: "0x62cf6e355c77edb6f5c8eb2085a85cf4de4c1852",
    chainId: 80094,
    decimals: 8,
    displayPrecision: 8,
    image: "/assets/tokens/bunibtc.svg",
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.beraborrow.com/den/borrow/unibtc",
    name: "bUNIBTC",
    protocol: "beraborrow",
    symbol: "bUNIBTC",
    type: "cdp"
}, {
    address: "0x28e0e3b9817012b356119df9e217c25932d609c2",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/burr.svg",
    isLpToken: !1,
    name: "Burr Governance Token",
    symbol: "BURR"
}, {
    address: "0x6751c09113a83a83a43829fd0b3bc0d7bdbe07bf",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/bwbera.svg",
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.beraborrow.com/den/borrow/wbera",
    name: "bWBERA",
    protocol: "beraborrow",
    symbol: "bWBERA",
    type: "cdp"
}, {
    address: "0x8628e618b66e7cddbe0adc84b96bea3977954507",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/bwgbera.svg",
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.beraborrow.com/den/borrow/wgbera",
    name: "bWGBERA",
    protocol: "beraborrow",
    symbol: "bWGBERA",
    type: "cdp"
}, {
    address: "0x688e72142674041f8f6af4c808a4045ca1d6ac82",
    chainId: 80094,
    decimals: 6,
    displayPrecision: 2,
    image: "/assets/tokens/byusd.svg",
    isLpToken: !1,
    name: "BYUSD",
    symbol: "BYUSD"
}, {
    address: "0xde04c469ad658163e2a5e860a03a86b52f6fa8c8",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/byusd.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0xde04c469ad658163e2a5e860a03a86b52f6fa8c8000000000000000000000000/details",
    name: "BYUSD",
    protocol: "bex",
    symbol: "BYUSD-HONEY-STABLE",
    type: "amm"
}, {
    address: "0x38920562047280f2f95b7aba7a9eaa8d0ae04a5c",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wbera-usdc.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x38920562047280f2f95b7aba7a9eaa8d0ae04a5c?chain=berachain_mainnet",
    name: "WBERA-USDC",
    protocol: "kodiak",
    symbol: "CHRM WBERA-USDC",
    type: "amm"
}, {
    address: "0x26bbc26415c6316890565f5f73017f85ee70b60c",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/dbusd.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isDepositDisabled: !0,
    isLpToken: !0,
    mintUrl: "https://app.madhoney.fi/vault",
    name: "dbUSD",
    protocol: "d8x",
    symbol: "dbUSD",
    type: "perpetuals"
}, {
    address: "0xbe75c8a7e58c7901d2e128dc8d3b6de2481f1f79",
    chainId: 80094,
    decimals: 6,
    displayPrecision: 2,
    image: "/assets/tokens/dgnberaland.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://d2.finance/strategies/dgnberaland?chainid=80094&tab=2",
    name: "dgnBeraland",
    protocol: "d2finance",
    symbol: "dgnBeraland",
    type: "vault"
}, {
    address: "0x7f2b60fdff1494a0e3e060532c9980d7fad0404b",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/dhoney.svg",
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.dolomite.io/balances",
    name: "dHONEY",
    protocol: "dolomite",
    symbol: "dHONEY",
    type: "cdp"
}, {
    address: "0x09d9420332bff75522a45fcff4855f82a0a3ff50",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/dinero.svg",
    isLpToken: !1,
    name: "Dinero OFT",
    symbol: "DINERO"
}, {
    address: "0x0f81001ef0a83ecce5ccebf63eb302c70a39a654",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/dolo.svg",
    isLpToken: !1,
    name: "Dolomite",
    symbol: "DOLO"
}, {
    address: "0x3000c6bf0aaeb813e252b584c4d9a82f99e7a71d",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/drusd.svg",
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.dolomite.io/balances",
    name: "drUSD",
    protocol: "dolomite",
    symbol: "drUSD",
    type: "cdp"
}, {
    address: "0xaa97d791afc02af30cf0b046172bb05b3c306517",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/dwbera.svg",
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.dolomite.io/balances",
    name: "dWBERA",
    protocol: "dolomite",
    symbol: "dWBERA",
    type: "cdp"
}, {
    address: "0xf7b5127b510e568fdc39e6bb54e2081bfad489af",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 4,
    image: "/assets/tokens/dweth.svg",
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.dolomite.io/balances",
    name: "dWETH",
    protocol: "dolomite",
    symbol: "dWETH",
    type: "cdp"
}, {
    address: "0x657e8c867d8b37dcc18fa4caead9c45eb088c642",
    chainId: 80094,
    decimals: 8,
    displayPrecision: 8,
    image: "/assets/tokens/ebtc.svg",
    isLpToken: !1,
    name: "ether.fi BTC",
    symbol: "eBTC"
}, {
    address: "0x112b77a77753b092306b1c04bd70215fed4e00a1",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/enect-1.svg",
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.euler.finance/vault/0x112b77a77753b092306b1c04bd70215fed4e00a1?network=berachain",
    name: "eNECT",
    protocol: "euler",
    symbol: "eNECT-1",
    type: "vault"
}, {
    address: "0xcaa70d2aa873ef057980844e18d9a9560bdffcc0",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/ewbera-4.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.euler.finance/vault/0xcaa70d2aa873ef057980844e18d9a9560bdffcc0?network=berachain",
    name: "EVK Vault eWBERA-4",
    protocol: "euler",
    symbol: "eWBERA-4",
    type: "cdp"
}, {
    address: "0x2416092f143378750bb29b79ed961ab195cceea5",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 4,
    image: "/assets/tokens/ezeth.svg",
    isLpToken: !1,
    name: "Renzo Restaked ETH",
    symbol: "ezETH"
}, {
    address: "0xbac93a69c62a1518136ff840b788ba715cbdfe2b",
    chainId: 80094,
    decimals: 8,
    displayPrecision: 8,
    image: "/assets/tokens/fbtc.svg",
    isLpToken: !1,
    name: "Fire Bitcoin",
    symbol: "FBTC"
}, {
    address: "0xca9088895e3390e503cac9ae95abaccdba20822e",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/grq.svg",
    isLpToken: !1,
    name: "GetRichQuick",
    symbol: "GRQ"
}, {
    address: "0xb2f776e9c1c926c4b2e54182fac058da9af0b6a5",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/henlo.svg",
    isLpToken: !1,
    name: "henlo",
    symbol: "HENLO"
}, {
    address: "0x5bad2b7a0a2eee88a4ef05d5470cdedb0ff948ea",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/hohm.svg",
    isLpToken: !1,
    mintUrl: "https://origami.finance/collections/berachain-collection/80094-0x5bad2b7a0a2eee88a4ef05d5470cdedb0ff948ea/info",
    name: "Origami hOHM",
    protocol: "origami",
    symbol: "hOHM",
    type: "unknown"
}, {
    address: "0xff0a636dfc44bb0129b631cdd38d21b613290c98",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/hold.svg",
    isLpToken: !1,
    name: "Holdstation",
    symbol: "HOLD"
}, {
    address: "0x36b933554782b108bb9962ac00c498acbceb706d",
    chainId: 80094,
    decimals: 6,
    displayPrecision: 2,
    image: "/assets/tokens/hyperbera-usdc.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://d2.finance/strategies/hyperbera.usdc?chainid=80094&tab=1",
    name: "USDC.e",
    protocol: "d2finance",
    symbol: "HyperBERA.USDC",
    type: "vault"
}, {
    address: "0x2ab43e4eecab510a92cc16cbe6d37891710696cb",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/wbtc-usdt0.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://app.charm.fi/berachain/vault/0x2ab43e4eecab510a92cc16cbe6d37891710696cb",
    name: "WBTC-USD₮0",
    protocol: "charm",
    symbol: "i-WBTC-USDT",
    type: "unknown"
}, {
    address: "0x9930bc9164f4e48352085b4655f77ca0cc30760d",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 4,
    image: "/assets/tokens/weth-usdc-e.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://app.charm.fi/berachain/vault/0x9930bc9164f4e48352085b4655f77ca0cc30760d",
    name: "WETH-USDC-E",
    protocol: "charm",
    symbol: "i-WETH-USDC.E",
    type: "unknown"
}, {
    address: "0x5bc9c1c2a387b7048f915e30bc3aa7820c9c67c3",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/ibera-wgbera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x5bc9c1c2a387b7048f915e30bc3aa7820c9c67c3000000000000000000000152/details",
    name: "iBERA-wgBERA",
    protocol: "bex",
    symbol: "iBERA-wgBERA-STABLE",
    type: "amm"
}, {
    address: "0x7ce7cb1893cfbd680cbfb9dd2a9ae6a62bde66a8",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/ibgt-lbgt.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://app.burrbear.io/#/berachain/pool/0x7ce7cb1893cfbd680cbfb9dd2a9ae6a62bde66a800000000000000000000000d/add-liquidity",
    name: "iBGT-LBGT",
    protocol: "burrbear",
    symbol: "iBGT-LBGT",
    type: "amm"
}, {
    address: "0xec06041013b3a97c58b9ab61eae9079bc594eda3",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/weth-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://wasabee.honeypotfinance.xyz/vault/0xec06041013b3a97c58b9ab61eae9079bc594eda3",
    name: "WETH-WBERA",
    protocol: "wasabee",
    symbol: "IV-WASABEE-2-WETH-WBERA",
    type: "amm"
}, {
    address: "0xe57d868d244d2cf2e9679eaba2a3048e58674565",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/wbera-ibera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://wasabee.honeypotfinance.xyz/vault/0xe57d868d244d2cf2e9679eaba2a3048e58674565",
    name: "WBERA-iBERA",
    protocol: "wasabee",
    symbol: "IV-WASABEE-3-WBERA-iBERA",
    type: "amm"
}, {
    address: "0xac04b1abadf214b57f7ade1dd905ab7acac23a6b",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/wbera-wgbera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://wasabee.honeypotfinance.xyz/vault/0xac04b1abadf214b57f7ade1dd905ab7acac23a6b",
    name: "WBERA-wgBERA",
    protocol: "wasabee",
    symbol: "IV-WASABEE-4-WBERA-wgBERA",
    type: "amm"
}, {
    address: "0x3640587709a387b54b0df555cd651a95a54fa900",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/bee-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://wasabee.honeypotfinance.xyz/vault/0x3640587709a387b54b0df555cd651a95a54fa900",
    name: "BEE-WBERA",
    protocol: "wasabee",
    symbol: "IV-WASABEE-7-BEE-WBERA",
    type: "amm"
}, {
    address: "0x57161d6272f47cd48ba165646c802f001040c2e0",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/beraeth-stone.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x57161d6272f47cd48ba165646c802f001040c2e0?chain=berachain_mainnet",
    name: "beraETH-STONE",
    protocol: "kodiak",
    symbol: "KODI beraETH-STONE",
    type: "amm"
}, {
    address: "0x7aef016302c3a27417372cf3aa74a1708d1ca291",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/beramo-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .01,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x7aef016302c3a27417372cf3aa74a1708d1ca291?chain=berachain_mainnet",
    name: "BERAMO-WBERA",
    protocol: "kodiak",
    symbol: "KODI BERAMO-WBERA",
    type: "amm"
}, {
    address: "0x1ac0e38ee5f66f6fa46e1644bb6b73bee598b953",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/brbtc-unibtc.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x1ac0e38ee5f66f6fa46e1644bb6b73bee598b953?chain=berachain_mainnet",
    name: "brBTC-uniBTC",
    protocol: "kodiak",
    symbol: "KODI brBTC-uniBTC",
    type: "amm"
}, {
    address: "0x54c603173ca92a42b81f8838d705fd3e0f98d5d4",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/bread-lbgt.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x54c603173ca92a42b81f8838d705fd3e0f98d5d4?chain=berachain_mainnet",
    name: "BREAD-LBGT",
    protocol: "kodiak",
    symbol: "KODI BREAD-LBGT",
    type: "amm"
}, {
    address: "0xd9a747880393f7c33cef1aea36909b36d421f7e5",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/bread-ohm.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xd9a747880393f7c33cef1aea36909b36d421f7e5?chain=berachain_mainnet",
    name: "BREAD-OHM",
    protocol: "kodiak",
    symbol: "KODI BREAD-OHM",
    type: "amm"
}, {
    address: "0x5e4fe86c4f6fb2203fbfb77fd6ec3cb300b639aa",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/dolo-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x5e4fe86c4f6fb2203fbfb77fd6ec3cb300b639aa?chain=berachain_mainnet",
    name: "DOLO-WBERA",
    protocol: "kodiak",
    symbol: "KODI DOLO-WBERA",
    type: "amm"
}, {
    address: "0x0b77545a4eb1b995e79bf85e0ed8d6ee288ca632",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/ewbera-4-osbgt.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x0b77545a4eb1b995e79bf85e0ed8d6ee288ca632?chain=berachain_mainnet",
    name: "eWBERA-4-osBGT",
    protocol: "kodiak",
    symbol: "KODI eWBERA-4-osBGT",
    type: "amm"
}, {
    address: "0x2a6f7008a884563df6fbf2d7676e696a44bb8896",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/hohm-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .01,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x2a6f7008a884563df6fbf2d7676e696a44bb8896?chain=berachain_mainnet",
    name: "hOHM-HONEY",
    protocol: "kodiak",
    symbol: "KODI hOHM-HONEY",
    type: "amm"
}, {
    address: "0x24afceb372b755f4953e738d6b38e9e4646d9f57",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/ibera-ibgt.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x24afceb372b755f4953e738d6b38e9e4646d9f57?chain=berachain_mainnet",
    name: "iBERA-iBGT",
    protocol: "kodiak",
    symbol: "KODI iBERA-iBGT",
    type: "amm"
}, {
    address: "0xad445256ff81171043a5e7cd8831e4371b000176",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/ibera-osbgt.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xad445256ff81171043a5e7cd8831e4371b000176?chain=berachain_mainnet",
    name: "iBERA-osBGT",
    protocol: "kodiak",
    symbol: "KODI iBERA-osBGT",
    type: "amm"
}, {
    address: "0x88c983bf3d4a9adcee14e1b4f1c446c4c5853ea3",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/ibera-wgbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x88c983bf3d4a9adcee14e1b4f1c446c4c5853ea3?chain=berachain_mainnet",
    name: "iBERA-wgBERA",
    protocol: "kodiak",
    symbol: "KODI iBERA-wgBERA",
    type: "amm"
}, {
    address: "0x5d3da311a5d3c22d257bb9943de9e55acda2f9cf",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/mbgt-ibera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x5d3da311a5d3c22d257bb9943de9e55acda2f9cf?chain=berachain_mainnet",
    name: "mBGT-iBERA",
    protocol: "kodiak",
    symbol: "KODI mBGT-iBERA",
    type: "amm"
}, {
    address: "0xef8c3239e0d8be9d58f145e18f5909ddad681365",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/nav-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .01,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xef8c3239e0d8be9d58f145e18f5909ddad681365?chain=berachain_mainnet",
    name: "NAV-WBERA",
    protocol: "kodiak",
    symbol: "KODI NAV-WBERA",
    type: "amm"
}, {
    address: "0x8ef48ae9df6165acc9754297bf28f5877c229c03",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/nect-usdt0.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x8ef48ae9df6165acc9754297bf28f5877c229c03?chain=berachain_mainnet",
    name: "NECT-USD₮0",
    protocol: "kodiak",
    symbol: "KODI NECT-USD₮0",
    type: "amm"
}, {
    address: "0x98bdeede9a45c28d229285d9d6e9139e9f505391",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/ohm-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x98bdeede9a45c28d229285d9d6e9139e9f505391?chain=berachain_mainnet",
    name: "OHM-HONEY",
    protocol: "kodiak",
    symbol: "KODI OHM-HONEY",
    type: "amm"
}, {
    address: "0xc227c8639a41db8393dd1b4eac41464a62d64fb4",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/ohm-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xc227c8639a41db8393dd1b4eac41464a62d64fb4?chain=berachain_mainnet",
    name: "OHM-WBERA",
    protocol: "kodiak",
    symbol: "KODI OHM-WBERA",
    type: "amm"
}, {
    address: "0x9b155cf7a4e5911ac35ab2173d0f58e1d39570fd",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/ooga-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .01,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x9b155cf7a4e5911ac35ab2173d0f58e1d39570fd?chain=berachain_mainnet",
    name: "OOGA-WBERA",
    protocol: "kodiak",
    symbol: "KODI OOGA-WBERA",
    type: "amm"
}, {
    address: "0xe38e2273df9ca6f2cd6f2ea0b13399e65bf799f1",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/plutus-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xe38e2273df9ca6f2cd6f2ea0b13399e65bf799f1?chain=berachain_mainnet",
    name: "PLUTUS-WBERA",
    protocol: "kodiak",
    symbol: "KODI PLUTUS-WBERA",
    type: "amm"
}, {
    address: "0x7fd165b73775884a38aa8f2b384a53a3ca7400e6",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/rusd-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x7fd165b73775884a38aa8f2b384a53a3ca7400e6?chain=berachain_mainnet",
    name: "rUSD-HONEY",
    protocol: "kodiak",
    symbol: "KODI rUSD-HONEY",
    type: "amm"
}, {
    address: "0x1fb6c1ade4f9083b2ea42ed3fa9342e41788d4b5",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/rusd-usdt0.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x1fb6c1ade4f9083b2ea42ed3fa9342e41788d4b5?chain=berachain_mainnet",
    name: "rUSD-USD₮0",
    protocol: "kodiak",
    symbol: "KODI rUSD-USD₮0",
    type: "amm"
}, {
    address: "0x4d1b02ff3ce55b816bb916ad8f80479434830ea4",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/sol-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x4d1b02ff3ce55b816bb916ad8f80479434830ea4?chain=berachain_mainnet",
    name: "SOL-HONEY",
    protocol: "kodiak",
    symbol: "KODI SOL-HONEY",
    type: "amm"
}, {
    address: "0x43e487126c4f37d1915cf02a90b5c5295afb1790",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 5,
    image: "/assets/tokens/solvbtc-xsolvbtc.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x43e487126c4f37d1915cf02a90b5c5295afb1790?chain=berachain_mainnet",
    name: "SolvBTC-xSolvBTC",
    protocol: "kodiak",
    symbol: "KODI SolvBTC-SolvBTC.BBN",
    type: "amm"
}, {
    address: "0xc60ea9801b3f1b01da373c05381e6ce8ff94d76f",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 7,
    image: "/assets/tokens/solvbtc-bnb-solvbtc.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .02,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xc60ea9801b3f1b01da373c05381e6ce8ff94d76f?chain=berachain_mainnet",
    name: "SolvBTC.BNB-SolvBTC-2%",
    protocol: "kodiak",
    symbol: "KODI SolvBTC.BNB-SolvBTC",
    type: "amm"
}, {
    address: "0xe21efa586cc88271c8c87642440ed49ccd000ccc",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/solvbtc-bnb-xsolvbtc.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xe21efa586cc88271c8c87642440ed49ccd000ccc?chain=berachain_mainnet",
    name: "SolvBTC.BNB-xSolvBTC",
    protocol: "kodiak",
    symbol: "KODI SolvBTC.BNB-xSolvBTC",
    type: "amm"
}, {
    address: "0x8b161685135e9fbc5475169e1addc0f2c4b7c343",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/stbgt-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x8b161685135e9fbc5475169e1addc0f2c4b7c343?chain=berachain_mainnet",
    name: "stBGT-WBERA",
    protocol: "kodiak",
    symbol: "KODI stBGT-WBERA",
    type: "amm"
}, {
    address: "0x7cebcc76a2faecc0ae378b340815fcbb71ec1fe0",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/susda-usda.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x7cebcc76a2faecc0ae378b340815fcbb71ec1fe0?chain=berachain_mainnet",
    name: "sUSDa-USDa",
    protocol: "kodiak",
    symbol: "KODI sUSDa-USDa",
    type: "amm"
}, {
    address: "0xd5b6ea3544a51bfdda7e6926bdf778339801dfe8",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/susde-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xd5b6ea3544a51bfdda7e6926bdf778339801dfe8?chain=berachain_mainnet",
    name: "sUSDe-HONEY",
    protocol: "kodiak",
    symbol: "KODI sUSDe-HONEY",
    type: "amm"
}, {
    address: "0x9a7d89284520572b3ec41efeba9add65622b301a",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/swbera-osbgt.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x9a7d89284520572b3ec41efeba9add65622b301a?chain=berachain_mainnet",
    name: "sWBERA-osBGT",
    protocol: "kodiak",
    symbol: "KODI sWBERA-osBGT",
    type: "amm"
}, {
    address: "0x28a54eaeec63fbb1175d13466a9ada5f3175d577",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/usdbr-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x28a54eaeec63fbb1175d13466a9ada5f3175d577?chain=berachain_mainnet",
    name: "USDbr-HONEY",
    protocol: "kodiak",
    symbol: "KODI USDbr-HONEY",
    type: "amm"
}, {
    address: "0xb73dee52f38539ba854979eab6342a60dd4c8c03",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 7,
    image: "/assets/tokens/usdc-e-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xb73dee52f38539ba854979eab6342a60dd4c8c03?chain=berachain_mainnet",
    name: "USDC.e-HONEY",
    protocol: "kodiak",
    symbol: "KODI USDC.e-HONEY",
    type: "amm"
}, {
    address: "0xe5a2ab5d2fb268e5ff43a5564e44c3309609aff9",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/usde-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xe5a2ab5d2fb268e5ff43a5564e44c3309609aff9?chain=berachain_mainnet",
    name: "USDe-HONEY",
    protocol: "kodiak",
    symbol: "KODI USDe-HONEY",
    type: "amm"
}, {
    address: "0x217b9476ecd8783c59ed0ed64c359b8f2b9ccd3a",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/wbera-aibera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x217b9476ecd8783c59ed0ed64c359b8f2b9ccd3a?chain=berachain_mainnet",
    name: "WBERA-AIBERA",
    protocol: "kodiak",
    symbol: "KODI WBERA-AIBERA",
    type: "amm"
}, {
    address: "0x2bdb8c39a3808eb9a03de69925b6b158a57c57e6",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/wbera-avl.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .01,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x2bdb8c39a3808eb9a03de69925b6b158a57c57e6?chain=berachain_mainnet",
    name: "WBERA-AVL",
    protocol: "kodiak",
    symbol: "KODI WBERA-AVL",
    type: "amm"
}, {
    address: "0x2cafe99db26cf86ae8587f5934830d25ad5c3cb3",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 6,
    image: "/assets/tokens/wbera-bitcoin.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .01,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x2cafe99db26cf86ae8587f5934830d25ad5c3cb3?chain=berachain_mainnet",
    name: "WBERA-BITCOIN",
    protocol: "kodiak",
    symbol: "KODI WBERA-BITCOIN",
    type: "amm"
}, {
    address: "0x0fd67ac75f9df51f5d81f582417b318f44b45f5c",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/bm-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .01,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x0fd67ac75f9df51f5d81f582417b318f44b45f5c?chain=berachain_mainnet",
    name: "bm-WBERA",
    protocol: "kodiak",
    symbol: "KODI WBERA-bm",
    type: "amm"
}, {
    address: "0x56449b16ff2b1e5ee61f532ceffda8f408f718a1",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/wbera-br.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .01,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x56449b16ff2b1e5ee61f532ceffda8f408f718a1?chain=berachain_mainnet",
    name: "WBERA-BR",
    protocol: "kodiak",
    symbol: "KODI WBERA-BR",
    type: "amm"
}, {
    address: "0x4a254b11810b8ebb63c5468e438fc561cb1bb1da",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wbera-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x4a254b11810b8ebb63c5468e438fc561cb1bb1da?chain=berachain_mainnet",
    name: "WBERA-HONEY",
    protocol: "kodiak",
    symbol: "KODI WBERA-HONEY",
    type: "amm"
}, {
    address: "0xe3eeb9e48934634d8b5b39a0d15dd89ee0f969c4",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/wbera-ibera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xe3eeb9e48934634d8b5b39a0d15dd89ee0f969c4?chain=berachain_mainnet",
    name: "WBERA-iBERA",
    protocol: "kodiak",
    symbol: "KODI WBERA-iBERA",
    type: "amm"
}, {
    address: "0x564f011d557aad1ca09bfc956eb8a17c35d490e0",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/wbera-ibgt.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x564f011d557aad1ca09bfc956eb8a17c35d490e0?chain=berachain_mainnet",
    name: "WBERA-iBGT",
    protocol: "kodiak",
    symbol: "KODI WBERA-iBGT",
    type: "amm"
}, {
    address: "0x9f6cf7acb2f16f7d906eeecb0a6020a5cf91a41d",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/wbera-lair.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x9f6cf7acb2f16f7d906eeecb0a6020a5cf91a41d?chain=berachain_mainnet",
    name: "WBERA-LAIR",
    protocol: "kodiak",
    symbol: "KODI WBERA-LAIR",
    type: "amm"
}, {
    address: "0x337ef1eb6c8bbed571170fc2b468608ab9e2aac8",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/wbera-lbgt.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x337ef1eb6c8bbed571170fc2b468608ab9e2aac8?chain=berachain_mainnet",
    name: "WBERA-LBGT",
    protocol: "kodiak",
    symbol: "KODI WBERA-LBGT",
    type: "amm"
}, {
    address: "0xd6620e78b89e8fdb5dfa675d55001c7fad424bdc",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/wbera-pollen.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .01,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xd6620e78b89e8fdb5dfa675d55001c7fad424bdc?chain=berachain_mainnet",
    name: "WBERA-POLLEN",
    protocol: "kodiak",
    symbol: "KODI WBERA-POLLEN",
    type: "amm"
}, {
    address: "0x93a913351cae2d8c82c4b85f699726947eb76d32",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/wbera-ramen.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .01,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x93a913351cae2d8c82c4b85f699726947eb76d32?chain=berachain_mainnet",
    name: "WBERA-RAMEN",
    protocol: "kodiak",
    symbol: "KODI WBERA-RAMEN",
    type: "amm"
}, {
    address: "0xfc4994e0a4780ba7536d7e79611468b6bde14cae",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/wbtc-ebtc.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xfc4994e0a4780ba7536d7e79611468b6bde14cae?chain=berachain_mainnet",
    name: "WBTC-eBTC",
    protocol: "kodiak",
    symbol: "KODI WBTC-eBTC",
    type: "amm"
}, {
    address: "0xf6b16e73d3b0e2784aae8c4cd06099be65d092bf",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/wbtc-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xf6b16e73d3b0e2784aae8c4cd06099be65d092bf?chain=berachain_mainnet",
    name: "WBTC-HONEY",
    protocol: "kodiak",
    symbol: "KODI WBTC-HONEY",
    type: "amm"
}, {
    address: "0x3879451f4f69f0c2d37cad45319cff2e7d29c596",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/wbtc-solvbtc.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x3879451f4f69f0c2d37cad45319cff2e7d29c596?chain=berachain_mainnet",
    name: "WBTC-SolvBTC",
    protocol: "kodiak",
    symbol: "KODI WBTC-SolvBTC",
    type: "amm"
}, {
    address: "0xb67d60fc02e0870eddca24d4fa8ea516c890152b",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/wbtc-unibtc.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xb67d60fc02e0870eddca24d4fa8ea516c890152b?chain=berachain_mainnet",
    name: "WBTC-uniBTC",
    protocol: "kodiak",
    symbol: "KODI WBTC-uniBTC",
    type: "amm"
}, {
    address: "0xf06ea29fcf4765200742d29e685973a1870eac98",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/wbtc-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xf06ea29fcf4765200742d29e685973a1870eac98?chain=berachain_mainnet",
    name: "WBTC-WBERA",
    protocol: "kodiak",
    symbol: "KODI WBTC-WBERA",
    type: "amm"
}, {
    address: "0x58fdb6eebf7df7ce4137994436fb0e629bb84b84",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/wbtc-weth.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x58fdb6eebf7df7ce4137994436fb0e629bb84b84?chain=berachain_mainnet",
    name: "WBTC-WETH",
    protocol: "kodiak",
    symbol: "KODI WBTC-WETH",
    type: "amm"
}, {
    address: "0x03bccf796cdef61064c4a2effdd21f1ac8c29e92",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/weth-beraeth.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x03bccf796cdef61064c4a2effdd21f1ac8c29e92?chain=berachain_mainnet",
    name: "WETH-beraETH",
    protocol: "kodiak",
    symbol: "KODI WETH-beraETH",
    type: "amm"
}, {
    address: "0xf6c6be0ff6d6f70a04dbe4f1ade62cb23053bd95",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/weth-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xf6c6be0ff6d6f70a04dbe4f1ade62cb23053bd95?chain=berachain_mainnet",
    name: "WETH-HONEY",
    protocol: "kodiak",
    symbol: "KODI WETH-HONEY",
    type: "amm"
}, {
    address: "0x97431f104be73fc0e6fc731ce84486da05c48871",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/weth-stone.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x97431f104be73fc0e6fc731ce84486da05c48871?chain=berachain_mainnet",
    name: "WETH-STONE",
    protocol: "kodiak",
    symbol: "KODI WETH-STONE",
    type: "amm"
}, {
    address: "0x9659dc8c1565e0bd82627267e3b4eed1a377ebe6",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/weth-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x9659dc8c1565e0bd82627267e3b4eed1a377ebe6?chain=berachain_mainnet",
    name: "WETH-WBERA",
    protocol: "kodiak",
    symbol: "KODI WETH-WBERA",
    type: "amm"
}, {
    address: "0xa0cabfc04fc420b3d31ba431d18eb5bd33b3f334",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/weth-weeth.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xa0cabfc04fc420b3d31ba431d18eb5bd33b3f334?chain=berachain_mainnet",
    name: "WETH-weETH",
    protocol: "kodiak",
    symbol: "KODI WETH-weETH",
    type: "amm"
}, {
    address: "0x939fb917bf8579c959094364708ef03f17e71f25",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 7,
    image: "/assets/tokens/xusd-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x939fb917bf8579c959094364708ef03f17e71f25?chain=berachain_mainnet",
    name: "xUSD-HONEY",
    protocol: "kodiak",
    symbol: "KODI xUSD-HONEY",
    type: "amm"
}, {
    address: "0x5347e5133b22a680ee94b7e62803e848f8d8c92e",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/ybgt-ybera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x5347e5133b22a680ee94b7e62803e848f8d8c92e?chain=berachain_mainnet",
    name: "yBGT-yBERA",
    protocol: "kodiak",
    symbol: "KODI yBGT-yBERA",
    type: "amm"
}, {
    address: "0x137bac38316075f6675027592b922a7f95a9dd97",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/yeet-osbgt.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x137bac38316075f6675027592b922a7f95a9dd97?chain=berachain_mainnet",
    name: "YEET-osBGT",
    protocol: "yeet",
    symbol: "KODI YEET-osBGT",
    type: "amm"
}, {
    address: "0xec8ba456b4e009408d0776cde8b91f8717d13fa1",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/yeet-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .01,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xec8ba456b4e009408d0776cde8b91f8717d13fa1?chain=berachain_mainnet",
    name: "YEET-WBERA",
    protocol: "kodiak",
    symbol: "KODI YEET-WBERA",
    type: "amm"
}, {
    address: "0x412c9f79779ae6c3a13a318252b29c559be756ca",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/yeet-wgbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x412c9f79779ae6c3a13a318252b29c559be756ca?chain=berachain_mainnet",
    name: "YEET-wgBERA",
    protocol: "kodiak",
    symbol: "KODI YEET-wgBERA",
    type: "amm"
}, {
    address: "0xabcea3ead918c3c5eca9b85d25b5e463a35a5e66",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/zero-ibgt.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xabcea3ead918c3c5eca9b85d25b5e463a35a5e66?chain=berachain_mainnet",
    name: "ZERO-iBGT",
    protocol: "kodiak",
    symbol: "KODI ZERO-iBGT",
    type: "amm"
}, {
    address: "0x091e41545e4a82e08f35bb51850e905537ced72e",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/zero-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x091e41545e4a82e08f35bb51850e905537ced72e?chain=berachain_mainnet",
    name: "ZERO-wBERA",
    protocol: "kodiak",
    symbol: "KODI ZERO-WBERA",
    type: "amm"
}, {
    address: "0x273c832797bfda1c0826a786670d041282bd6afc",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/krt.svg",
    isLpToken: !1,
    isSoulbound: !0,
    isUnpriced: !0,
    mintUrl: "https://exchange.kuma.bid/rewards/trade",
    name: "Kuma Reward Token",
    protocol: "kuma",
    symbol: "KRT",
    type: "unknown"
}, {
    address: "0xf3530788deb3d21e8fa2c3cbbf93317fb38a0d3c",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/lair.svg",
    isLpToken: !1,
    name: "LAIR",
    symbol: "LAIR"
}, {
    address: "0xbaadcc2962417c01af99fb2b7c75706b9bd6babe",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/lbgt.svg",
    isLpToken: !1,
    name: "Liquid BGT",
    symbol: "LBGT"
}, {
    address: "0xecac9c5f704e954931349da37f60e39f515c11c1",
    chainId: 80094,
    decimals: 8,
    displayPrecision: 8,
    image: "/assets/tokens/lbtc.svg",
    isLpToken: !1,
    name: "Lombard Staked Bitcoin",
    symbol: "LBTC"
}, {
    address: "0xb7e448e5677d212b8c8da7d6312e8afc49800466",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/locks.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://www.goldilocks.io/goldiswap/swap",
    name: "Locks",
    protocol: "goldilocks",
    symbol: "LOCKS",
    type: "amm"
}, {
    address: "0x927439eef2e2520afa78d8742cae7be3e3e90b11",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/mbgt.svg",
    isLpToken: !1,
    name: "market BGT",
    symbol: "mBGT"
}, {
    address: "0xedb5180661f56077292c92ab40b1ac57a279a396",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/mead.svg",
    isLpToken: !1,
    name: "Roots Stable",
    symbol: "MEAD"
}, {
    address: "0x2a9ea10b60ab02e9b8960a08b4996e6bf5ea5eab",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/mead-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x2a9ea10b60ab02e9b8960a08b4996e6bf5ea5eab000000000000000000000162/details",
    name: "MEAD-HONEY",
    protocol: "bex",
    symbol: "MEAD-HONEY-STABLE",
    type: "amm"
}, {
    address: "0x5b82028cfc477c4e7dda7ff33d59a23fa7be002a",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/mim.svg",
    isLpToken: !1,
    name: "Magic Internet Money",
    symbol: "MIM"
}, {
    address: "0xde1392209e55313284f144f8e76dcbb1c8a2eee3",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/nana.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    isSoulbound: !0,
    isUnpriced: !0,
    mintUrl: "https://vault.narralayer.ai",
    name: "NO AIRDROP NO ALPHA",
    protocol: "narra",
    symbol: "NANA",
    type: "unknown"
}, {
    address: "0x6536cead649249cae42fc9bfb1f999429b3ec755",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/nav.svg",
    isLpToken: !1,
    name: "NavFinance",
    symbol: "NAV"
}, {
    address: "0x1ce0a25d13ce4d52071ae7e02cf1f6606f4c79d3",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/nect.svg",
    isLpToken: !1,
    name: "Nectar",
    symbol: "NECT"
}, {
    address: "0x0af0aee92cd4f6b65fe22b2ca6a2c8862f3c6b9f",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/nect-bold-honey.svg",
    imageCount: 3,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x0af0aee92cd4f6b65fe22b2ca6a2c8862f3c6b9f0000000000000000000001b5/details/",
    name: "NECT-BOLD-HONEY",
    protocol: "bex",
    symbol: "NECT-BOLD-HONEY-STABLE",
    type: "amm"
}, {
    address: "0xb34fca9739249578d93a22ce02bf7fad277bad35",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/nect-usdc-e-usdt0-honey.svg",
    imageCount: 4,
    isLpToken: !0,
    mintUrl: "https://app.burrbear.io/#/berachain/pool/0xb34fca9739249578d93a22ce02bf7fad277bad35000000000000000000000013/add-liquidity",
    name: "NECT-USDC.e-USD₮0-HONEY",
    protocol: "burrbear",
    symbol: "NECT-USDC.e-USD₮0-HONEY",
    type: "amm"
}, {
    address: "0xd10e65a5f8ca6f835f2b1832e37cf150fb955f23",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/nect-usdc-e-honey.svg",
    imageCount: 3,
    isLpToken: !0,
    mintUrl: "https://app.burrbear.io/#/berachain/pool/0xd10e65a5f8ca6f835f2b1832e37cf150fb955f23000000000000000000000004/add-liquidity",
    name: "NECT-USDC.e-HONEY",
    protocol: "burrbear",
    symbol: "NECT/USDC/HONEY",
    type: "amm"
}, {
    address: "0x18878df23e2a36f81e820e4b47b4a40576d3159c",
    chainId: 80094,
    decimals: 9,
    displayPrecision: 3,
    image: "/assets/tokens/ohm.svg",
    isLpToken: !1,
    name: "Olympus",
    symbol: "OHM"
}, {
    address: "0x009af46df68db0e76bfe9ea35663f6ed17877956",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/ooga.svg",
    isLpToken: !1,
    name: "Ooga Token",
    symbol: "OOGA"
}, {
    address: "0x69f1e971257419b1e9c405a553f252c64a29a30a",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/oribgt.svg",
    isLpToken: !1,
    mintUrl: "https://origami.finance/collections/berachain-collection/80094-0x69f1e971257419b1e9c405a553f252c64a29a30a/info",
    name: "Origami iBGT Auto-Compounder",
    protocol: "origami",
    symbol: "oriBGT",
    type: "unknown"
}, {
    address: "0x978448a7866aed0146ad5c5e5d3d8424e2b16356",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/oribgtot.svg",
    isLpToken: !1,
    name: "oriBGT-OT",
    symbol: "oriBGTOT"
}, {
    address: "0xd2c41bf4033a83c0fc3a7f58a392bf37d6dcdb58",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/osbgt.svg",
    isLpToken: !1,
    name: "OpenState BGT",
    symbol: "osBGT"
}, {
    address: "0x02293d88656860a840ed457d38f51e3e6bee8461",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/pendle-ibgt.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.pendle.finance/trade/pools/0x02293d88656860a840ed457d38f51e3e6bee8461/zap/in?chain=bera",
    name: "Pendle iBGT",
    protocol: "pendle",
    symbol: "PENDLE-LPT",
    type: "amm"
}, {
    address: "0xc2605ed80880bd6b1523d52aef8d624ed468a935",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/pendle-ibgt.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.pendle.finance/trade/pools/0x02293d88656860a840ed457d38f51e3e6bee8461/zap/lp-wrapper/wrap?chain=bera",
    name: "Pendle iBGT",
    protocol: "pendle",
    symbol: "PENDLE-LPT-WRAPPED",
    type: "vault"
}, {
    address: "0x231a6bd8eb88cfa42776b7ac575cecaf82bf1e21",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/plug.svg",
    isLpToken: !1,
    name: "Beraplug",
    symbol: "PLUG"
}, {
    address: "0x6698ede14709a9dd8379744cc2d28f276e3d2eac",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/plutus.svg",
    isLpToken: !1,
    name: "Plutus token",
    symbol: "PLUTUS"
}, {
    address: "0xc99e948e9d183848a6c4f5e6c1d225f02f171d79",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/pollen.svg",
    isLpToken: !1,
    name: "POLLEN",
    symbol: "POLLEN"
}, {
    address: "0x46fcd35431f5b371224acc2e2e91732867b1a77e",
    chainId: 80094,
    decimals: 8,
    displayPrecision: 8,
    image: "/assets/tokens/primeliquidberabtc.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isDepositDisabled: !0,
    isLpToken: !1,
    isNotWorkingWithEnso: !0,
    mintUrl: "https://www.ether.fi/app/liquid/bera-btc",
    name: "primeLiquidBeraBTC",
    protocol: "etherfi",
    symbol: "primeLiquidBeraBTC",
    type: "vault"
}, {
    address: "0xb83742330443f7413dbd2abdfc046db0474a944e",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 4,
    image: "/assets/tokens/primeliquidberaeth.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isDepositDisabled: !0,
    isLpToken: !1,
    isNotWorkingWithEnso: !0,
    mintUrl: "https://www.ether.fi/app/liquid/bera-eth",
    name: "primeLiquidBeraETH",
    protocol: "etherfi",
    symbol: "primeLiquidBeraETH",
    type: "vault"
}, {
    address: "0xb8b1af593dc37b33a2c87c8db1c9051fc32858b7",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/ramen.svg",
    isLpToken: !1,
    name: "RAMEN",
    symbol: "RAMEN"
}, {
    address: "0x09d4214c03d01f49544c0448dbe3a27f768f2b34",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/rusd.svg",
    isLpToken: !1,
    name: "Reservoir Stablecoin",
    symbol: "rUSD"
}, {
    address: "0xff21f46bc9d78125705eef6efca62f9420cfdb9b",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/satsolvbtc-bera.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.satlayer.xyz/vaults/restake",
    name: "satSolvBTC.BERA",
    protocol: "satlayer",
    symbol: "satSolvBTC.BERA",
    type: "vault"
}, {
    address: "0xd948212f077e552533158becbc1882c1b19c40fe",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/shoney.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.wasabi.xyz/earn?vault=shoney&network=berachain",
    name: "sHONEY",
    protocol: "wasabi",
    symbol: "sHONEY",
    type: "cdp"
}, {
    address: "0x597877ccf65be938bd214c4c46907669e3e62128",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/snect.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.beraborrow.com/pool/deposit",
    name: "sNECT",
    protocol: "beraborrow",
    symbol: "sNECT",
    type: "cdp"
}, {
    address: "0x225b86198ba36321a8a840291416aed62494043f",
    chainId: 80094,
    decimals: 9,
    displayPrecision: 3,
    image: "/assets/tokens/wrapped-sol.svg",
    isLpToken: !1,
    name: "Wrapped SOL",
    symbol: "SOL"
}, {
    address: "0x541fd749419ca806a8bc7da8ac23d346f2df8b77",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/solvbtc.svg",
    isLpToken: !1,
    name: "Solv BTC",
    symbol: "SolvBTC"
}, {
    address: "0x0f6f337b09cb5131cf0ce9df3beb295b8e728f3b",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/solvbtc-bera.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.solv.finance/bera?network=bera",
    name: "SolvBTC.BERA",
    protocol: "solv",
    symbol: "SolvBTC.BERA",
    type: "vault"
}, {
    address: "0x1b25ca174c158440621ff96e4b1262cb5cc8942f",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/solvbtc-bnb.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.solv.finance/bnb?network=bera",
    name: "SolvBTC.BNB",
    protocol: "solv",
    symbol: "SolvBTC.BNB",
    type: "vault"
}, {
    address: "0x2cec7f1ac87f5345ced3d6c74bbb61bfae231ffb",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/stbgt.svg",
    isLpToken: !1,
    name: "stBGT",
    symbol: "stBGT"
}, {
    address: "0xdb78b4166580917c9604f8ddfbea5f49b493845c",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/oribgt-oribgtot.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://app.steer.finance/vault/0xdb78b4166580917c9604f8ddfbea5f49b493845c",
    name: "oriBGT-oriBGTOT",
    protocol: "steer",
    symbol: "STEERUV20",
    type: "amm"
}, {
    address: "0x9895d81bb462a195b4922ed7de0e3acd007c32cb",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/stg.svg",
    isLpToken: !1,
    name: "StargateToken",
    symbol: "STG"
}, {
    address: "0x0435c32c79e8341e44047493ba371b502b8c90af",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/ewbera-wgbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 5e-4,
    mintUrl: "https://www.winnieswap.com/vaults/0x0435c32c79e8341e44047493ba371b502b8c90af",
    name: "ewBERA-wgBERA",
    protocol: "winnieswap",
    symbol: "STICKY eWBERA-4-wgBERA",
    type: "amm"
}, {
    address: "0xa5b3ecafbfcc7946c11a28252c6f2bdb73d30388",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/nect-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: 1e-4,
    mintUrl: "https://www.winnieswap.com/vaults/0xa5b3ecafbfcc7946c11a28252c6f2bdb73d30388",
    name: "NECT-HONEY",
    protocol: "winnieswap",
    symbol: "STICKY NECT-HONEY",
    type: "amm"
}, {
    address: "0xec901da9c68e90798bbbb74c11406a32a70652c3",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 4,
    image: "/assets/tokens/stone.svg",
    isLpToken: !1,
    name: "StakeStone Ether",
    symbol: "STONE"
}, {
    address: "0x2840f9d9f96321435ab0f977e7fdbf32ea8b304f",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/susda.svg",
    isLpToken: !1,
    name: "USDa saving token",
    symbol: "sUSDa"
}, {
    address: "0x211cc4dd073734da055fbf44a2b4667d5e5fe5d2",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/susde.svg",
    isLpToken: !1,
    name: "Staked USDe",
    symbol: "sUSDe"
}, {
    address: "0x118d2ceee9785eaf70c15cd74cd84c9f8c3eec9a",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/pol-staked-wbera.svg",
    isLpToken: !1,
    mintUrl: "https://hub.berachain.com/stake/",
    name: "POL Staked WBERA",
    symbol: "sWBERA"
}, {
    address: "0xc95ab9eff8fb48760703c74416764b8f898afa1b",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/swbera.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.wasabi.xyz/earn?vault=swbera&network=berachain",
    name: "sWBERA",
    protocol: "wasabi",
    symbol: "sWBERA",
    type: "cdp"
}, {
    address: "0xe454c546c8f3875e928910abc653de5f8c432f11",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/bixbt-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xe454c546c8f3875e928910abc653de5f8c432f11?chain=berachain_mainnet",
    name: "BIXBT-WBERA",
    protocol: "kodiak",
    symbol: "UNI-V2",
    type: "amm"
}, {
    address: "0xdca120bd3a13250b67f6faa5c29c1f38ec6ebece",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/hold-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xdca120bd3a13250b67f6faa5c29c1f38ec6ebece?chain=berachain_mainnet",
    name: "HOLD-WBERA",
    protocol: "kodiak",
    symbol: "UNI-V2",
    type: "amm"
}, {
    address: "0xac1d44f0284634eb04ffa56c76d47e839224b46f",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/plug-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0xac1d44f0284634eb04ffa56c76d47e839224b46f?chain=berachain_mainnet",
    name: "PLUG-WBERA",
    protocol: "kodiak",
    symbol: "UNI-V2",
    type: "unknown"
}, {
    address: "0x68cac522833f38e088eec5e356956c02f0268063",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 1,
    image: "/assets/tokens/wbera-grq.svg",
    imageCount: 2,
    isLpToken: !0,
    kodiakTradingFee: .003,
    mintUrl: "https://app.kodiak.finance/#/liquidity/pools/0x68cac522833f38e088eec5e356956c02f0268063?chain=berachain_mainnet",
    name: "WBERA-GRQ",
    protocol: "kodiak",
    symbol: "UNI-V2",
    type: "amm"
}, {
    address: "0xc3827a4bc8224ee2d116637023b124ced6db6e90",
    chainId: 80094,
    decimals: 8,
    displayPrecision: 8,
    image: "/assets/tokens/unibtc.svg",
    isLpToken: !1,
    name: "uniBTC",
    symbol: "uniBTC"
}, {
    address: "0x779ded0c9e1022225f8e0630b35a9b54be713736",
    chainId: 80094,
    decimals: 6,
    displayPrecision: 2,
    image: "/assets/tokens/usdt0.svg",
    isLpToken: !1,
    name: "USD₮0",
    symbol: "USD₮0"
}, {
    address: "0xff12470a969dd362eb6595ffb44c82c959fe9acc",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/usda.svg",
    isLpToken: !1,
    name: "USDa",
    symbol: "USDa"
}, {
    address: "0x6d4223dae2a8744a85a6d44e97f3f61679f87ee6",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/usdbr.svg",
    isLpToken: !1,
    name: "USDbr",
    symbol: "USDbr"
}, {
    address: "0x549943e04f40284185054145c6e4e9568c1d3241",
    chainId: 80094,
    decimals: 6,
    displayPrecision: 2,
    image: "/assets/tokens/usdc-e.svg",
    isLpToken: !1,
    name: "Bridged USDC (Stargate)",
    symbol: "USDC.e"
}, {
    address: "0xf961a8f6d8c69e7321e78d254ecafbcc3a637621",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/usdc-e-honey.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0xf961a8f6d8c69e7321e78d254ecafbcc3a637621000000000000000000000001/details",
    name: "USDC.e-HONEY",
    protocol: "bex",
    symbol: "USDC.e-HONEY-STABLE",
    type: "amm"
}, {
    address: "0x5d3a1ff2b6bab83b63cd9ad0787074081a52ef34",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/usde.svg",
    isLpToken: !1,
    name: "USDe",
    symbol: "USDe"
}, {
    address: "0x6ee01549960f47b2e64cb9fb26a9107e735910b5",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/very-awesome-unified-liquidity-token.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    isSoulbound: !0,
    mintUrl: "https://honeypotfinance.xyz",
    name: "Very Awesome Unified Liquidity Token",
    protocol: "honeypot",
    symbol: "VAULT",
    type: "unknown"
}, {
    address: "0x62c030b29a6fef1b32677499e4a1f1852a8808c0",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wbera-ibera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x62c030b29a6fef1b32677499e4a1f1852a8808c00000000000000000000000c6/details",
    name: "WBERA-iBERA",
    protocol: "bex",
    symbol: "WBERA-iBERA-STABLE",
    type: "amm"
}, {
    address: "0x567f32e86be3e3963cdbc1887b5043b701f113d9",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wbera-wgbera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://app.burrbear.io/#/berachain/pool/0x567f32e86be3e3963cdbc1887b5043b701f113d9000000000000000000000006/add-liquidity",
    name: "WBERA-wgBERA",
    protocol: "burrbear",
    symbol: "WBERA-wgBERA",
    type: "amm"
}, {
    address: "0x0555e30da8f98308edb960aa94c0db47230d2b9c",
    chainId: 80094,
    decimals: 8,
    displayPrecision: 8,
    image: "/assets/tokens/wbtc.svg",
    isLpToken: !1,
    name: "WBTC",
    symbol: "WBTC"
}, {
    address: "0xcbef1b65399065c2de2c495971e90466ff38f2d0",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 8,
    image: "/assets/tokens/wbtc-solvbtc-xsolvbtc.svg",
    imageCount: 3,
    isLpToken: !0,
    mintUrl: "https://app.burrbear.io/#/berachain/pool/0xcbef1b65399065c2de2c495971e90466ff38f2d000000000000000000000001e/add-liquidity",
    name: "WBTC-SolvBTC-xSolvBTC",
    protocol: "burrbear",
    symbol: "WBTC/solvBTC/xSolvBTC",
    type: "amm"
}, {
    address: "0x334404782ab67b4f6b2a619873e579e971f9aab7",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/wbyusd.svg",
    isLpToken: !1,
    name: "Wrapped BYUSD",
    symbol: "wBYUSD"
}, {
    address: "0x7dcc39b4d1c53cb31e1abc0e358b43987fef80f7",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 4,
    image: "/assets/tokens/weeth.svg",
    isLpToken: !1,
    name: "Wrapped eETH",
    symbol: "weETH"
}, {
    address: "0x396a3d0b799b1a0b1eaa17e75b4dea412400860b",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/weibera.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.webera.finance/vault?token=ibera&type=bera-lst",
    name: "weiBERA",
    protocol: "webera",
    symbol: "weiBERA",
    type: "cdp"
}, {
    address: "0x2f6f07cdcf3588944bf4c42ac74ff24bf56e7590",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 4,
    image: "/assets/tokens/weth.svg",
    isLpToken: !1,
    name: "WETH",
    symbol: "WETH"
}, {
    address: "0x258d8933b625566fbe057874121783a2808adafa",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 4,
    image: "/assets/tokens/weth-beraeth.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x258d8933b625566fbe057874121783a2808adafa0000000000000000000000c1/details",
    name: "WETH-beraETH",
    protocol: "bex",
    symbol: "WETH-beraETH-STABLE",
    type: "amm"
}, {
    address: "0x55a050f76541c2554e9dfa3a0b4e665914bf92ea",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wewbera.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    mintUrl: "https://app.webera.finance/vault?token=bera&type=lend/borrow",
    name: "weWBERA",
    protocol: "webera",
    symbol: "weWBERA",
    type: "cdp"
}, {
    address: "0xd77552d3849ab4d8c3b189a9582d0ba4c1f4f912",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wgbera.svg",
    isLpToken: !1,
    name: "wgBERA",
    symbol: "wgBERA"
}, {
    address: "0x8f32c1b7c9e2c60d357b7949a43540162248a21e",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wgbera-wbera.svg",
    imageCount: 2,
    isLpToken: !0,
    mintUrl: "https://hub.berachain.com/pools/0x8f32c1b7c9e2c60d357b7949a43540162248a21e00000000000000000000014a/details/",
    name: "wgBERA-WBERA",
    protocol: "bex",
    symbol: "wgBERA-WBERA-STABLE",
    type: "amm"
}, {
    address: "0x4f3c10d2bc480638048fa67a7d00237a33670c1b",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/wibgt.svg",
    isLpToken: !1,
    name: "wiBGT",
    symbol: "wiBGT"
}, {
    address: "0x01c8a5ccad23a4d3764ef71c403862160aa2913a",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/wizz.svg",
    isLpToken: !1,
    name: "Wizzwoods Token",
    symbol: "WIZZ"
}, {
    address: "0xcac89b3f94ed6bab04113884deee2a55293c2dd7",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/xfatbera.svg",
    isLpToken: !1,
    name: "Extra FatBERA",
    symbol: "xfatBERA"
}, {
    address: "0xcc0966d8418d412c599a6421b760a847eb169a8c",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 7,
    image: "/assets/tokens/xsolvbtc.svg",
    isLpToken: !1,
    name: "xSolvBTC",
    symbol: "xSolvBTC"
}, {
    address: "0x6eaf19b2fc24552925db245f9ff613157a7dbb4c",
    chainId: 80094,
    decimals: 6,
    displayPrecision: 2,
    image: "/assets/tokens/xusd.svg",
    isLpToken: !1,
    name: "Staked Stream USD",
    symbol: "xUSD"
}, {
    address: "0x4e1d8c85a1061816b22c109b221dead1690f9c00",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/ybb.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    isSoulbound: !0,
    mintUrl: "https://yeetit.xyz",
    name: "Yeetarded Buyback",
    protocol: "yeet",
    symbol: "YBB",
    type: "unknown"
}, {
    address: "0x982940ebfc5caa2f5b5a82aac2dfa99f18bb7da4",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 3,
    image: "/assets/tokens/ybera.svg",
    isLpToken: !1,
    name: "Bearn BERA",
    symbol: "yBERA"
}, {
    address: "0x7e768f47dfdd5dae874aac233f1bc5817137e453",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/ybgt.svg",
    isLpToken: !1,
    name: "Bearn BGT",
    symbol: "yBGT"
}, {
    address: "0x08a38caa631de329ff2dad1656ce789f31af3142",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/yeet.svg",
    isLpToken: !1,
    mintUrl: "https://yeetit.xyz",
    name: "YEET",
    protocol: "yeet",
    symbol: "YEET",
    type: "unknown"
}, {
    address: "0xd7cfdd9514b6ef10e9cf271cf62955530adbc4ec",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 2,
    image: "/assets/tokens/yeet-rwt.svg",
    imageNotFromUnderlying: !0,
    imageCount: 1,
    isLpToken: !1,
    isSoulbound: !0,
    mintUrl: "https://yeetit.xyz",
    name: "Yeet",
    protocol: "yeet",
    symbol: "YEET-RWT",
    type: "unknown"
}, {
    address: "0x0000382fbb422b4f593931fc6f2d25cc16600000",
    chainId: 80094,
    decimals: 18,
    displayPrecision: 0,
    image: "/assets/tokens/zero.svg",
    isLpToken: !1,
    name: "Zero",
    symbol: "ZERO"
}]